/*! proton-sticky-atc.js — mobile sticky Add-to-Cart bar on product pages.
 * Why: CRO audit 2026-10-13 — on a 390x844 phone the real Add to Cart sits at
 * y=939 (Coyote) / 924 (Peacock) / 1048 (Yee Yee), below the fold, on 80%+ of traffic.
 * Behaviour:
 *  - /products/* only, <=749px only.
 *  - Shows only while the REAL add button is off-screen; hides when it is visible.
 *  - Tap = .click() on the real theme button, so variant choice, the upsell drawer,
 *    the checkout intercept and every existing cart hook behave exactly as before.
 *  - Sold out / coming soon (real button disabled): mirrors the real label and
 *    scrolls to the buy box (where the back-in-stock form lives). Never adds.
 *  - Hides while any overlay/drawer/modal is open; lifts the "Get 10%" tab above itself.
 * Remove: node scripts/sticky-atc/_sticky-atc-install.js --remove
 */
(function () {
  'use strict';
  if (window.__protonStickyAtc) return;
  window.__protonStickyAtc = true;
  if (!/^\/products\//.test(location.pathname)) return;

  var MQ = window.matchMedia('(max-width: 749px)');

  function realButton() {
    return document.querySelector('form[id^="product-form-template"][id$="__main"] button[name="add"]') ||
      document.querySelector('section[id*="__main"] product-form button[name="add"]') ||
      document.querySelector('product-form button[name="add"]');
  }
  function priceText() {
    var box = document.querySelector('[id^="price-template"][id$="__main"]') || document.querySelector('.product__info-container .price');
    if (!box) return '';
    var el = box.querySelector('.price--on-sale .price-item--last') || box.querySelector('.price__regular .price-item--regular') || box.querySelector('.price-item');
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function compareText() {
    var box = document.querySelector('[id^="price-template"][id$="__main"]');
    if (!box) return '';
    var on = box.querySelector('.price--on-sale');
    if (!on) return '';
    var s = on.querySelector('.price__sale s, s.price-item--regular');
    return s ? s.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function titleText() {
    var h = document.querySelector('.product__title h1') || document.querySelector('.product__title');
    return h ? h.textContent.replace(/\s+/g, ' ').trim() : document.title.split('–')[0].trim();
  }

  var css = '' +
    '#pp-satc{position:fixed;left:0;right:0;bottom:0;z-index:2147481000;display:flex;align-items:center;gap:12px;' +
    'padding:10px 12px calc(10px + env(safe-area-inset-bottom,0px));' +
    'background:rgba(17,14,12,.78);backdrop-filter:blur(14px) saturate(140%);-webkit-backdrop-filter:blur(14px) saturate(140%);' +
    'border-top:1px solid rgba(255,255,255,.10);box-shadow:0 -8px 30px rgba(0,0,0,.35);' +
    'transform:translateY(120%);transition:transform .28s cubic-bezier(.22,1,.36,1);}' +
    '#pp-satc.pp-show{transform:translateY(0);}' +
    '#pp-satc .ps-info{display:flex;flex-direction:column;min-width:0;flex:1 1 auto;line-height:1.15;}' +
    '#pp-satc .ps-title{font-size:12px;font-weight:600;color:rgba(222,202,164,.9);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}' +
    '#pp-satc .ps-price{font-size:18px;font-weight:800;color:#fff;font-variant-numeric:tabular-nums;white-space:nowrap;}' +
    '#pp-satc .ps-price s{font-size:13px;font-weight:500;color:rgba(255,255,255,.55);margin-left:6px;}' +
    '#pp-satc .ps-note{font-size:11px;color:rgba(255,255,255,.7);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}' +
    '#pp-satc .ps-btn{flex:0 0 auto;appearance:none;border:0;cursor:pointer;white-space:nowrap;' +
    'padding:14px 16px;border-radius:14px;font-size:16px;font-weight:800;color:#1a1206;' +
    'background:linear-gradient(135deg,#FFB44D 0%,#FF6000 55%,#F24E00 100%);' +
    'box-shadow:0 6px 22px rgba(255,96,0,.45),inset 0 1px 0 rgba(255,255,255,.35);transition:transform .12s ease;}' +
    '#pp-satc .ps-btn:active{transform:scale(.97);}' +
    '#pp-satc .ps-btn.ps-off{background:#3a3631;color:#e8e1d6;box-shadow:none;}' +
    'body.pp-satc-ovl #pwp-tab{display:none !important;}' +
    'body.pp-satc-on #pwp-tab{bottom:calc(86px + env(safe-area-inset-bottom,0px)) !important;}' +
    'body:has(#pu-ck) #pp-satc,body:has(#pp-sticky-checkout.pp-show) #pp-satc{display:none !important;}' +
    '@media (min-width:750px){#pp-satc{display:none !important;}}';

  function init() {
    var btn = realButton();
    if (!btn) return;

    var st = document.createElement('style');
    st.id = 'pp-satc-css';
    st.textContent = css;
    document.head.appendChild(st);

    var bar = document.createElement('div');
    bar.id = 'pp-satc';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');
    bar.innerHTML = '<div class="ps-info"><span class="ps-title"></span><span class="ps-price"></span><span class="ps-note"></span></div>' +
      '<button type="button" class="ps-btn">Add to cart</button>';
    document.body.appendChild(bar);
    var elT = bar.querySelector('.ps-title'), elP = bar.querySelector('.ps-price'),
      elN = bar.querySelector('.ps-note'), elB = bar.querySelector('.ps-btn');

    var realVisible = true;

    function cents(txt) {
      var m = (txt || '').replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
      return m ? Math.round(parseFloat(m[1]) * 100) : 0;
    }
    function render() {
      var b = realButton() || btn;
      elT.textContent = titleText();
      var p = priceText(), c = compareText();
      elP.innerHTML = '';
      elP.appendChild(document.createTextNode(p));
      if (c && c !== p) { var s = document.createElement('s'); s.textContent = c; elP.appendChild(s); }
      var tr = document.querySelector('.pp-trust');
      var g30 = !!(tr && /30[- ]day/i.test(tr.textContent || ''));
      var bits = [];
      if (cents(p) >= 7500) bits.push('Free shipping');
      if (g30) bits.push('30-day guarantee');
      elN.textContent = bits.join(' · ');
      elN.style.whiteSpace = 'nowrap';
      if (elN.scrollWidth > elN.clientWidth + 1) elN.style.whiteSpace = 'normal';
      var off = b.disabled || b.getAttribute('aria-disabled') === 'true';
      elB.classList.toggle('ps-off', off);
      var label = (b.textContent || '').replace(/\s+/g, ' ').trim();
      elB.textContent = off ? (label || 'Sold out') : 'Add to cart';
    }

    function overlayOpen() {
      var de = document.documentElement, bd = document.body;
      if (bd.classList.contains('overflow-hidden') || bd.classList.contains('overflow-hidden-mobile')) return true;
      if (getComputedStyle(bd).overflow === 'hidden' || getComputedStyle(de).overflow === 'hidden') return true;
      var ids = ['pwp-ov', 'pu-ck', 'pu-drawer', 'bis-modal', 'pp-bis-modal'];
      for (var i = 0; i < ids.length; i++) {
        var e = document.getElementById(ids[i]);
        if (e && e.offsetParent !== null && getComputedStyle(e).visibility !== 'hidden') return true;
      }
      var cd = document.querySelector('cart-drawer.active, cart-notification.active, .drawer.active');
      return !!cd;
    }

    function update() {
      var ovl = overlayOpen();
      document.body.classList.toggle('pp-satc-ovl', ovl && !document.getElementById('pwp-ov'));
      var show = MQ.matches && !realVisible && !ovl;
      bar.classList.toggle('pp-show', show);
      document.body.classList.toggle('pp-satc-on', show);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        realVisible = es[0].isIntersecting;
        update();
      }, { threshold: 0 }).observe(btn);
    } else {
      window.addEventListener('scroll', function () {
        var r = btn.getBoundingClientRect();
        realVisible = r.bottom > 0 && r.top < innerHeight;
        update();
      }, { passive: true });
    }

    elB.addEventListener('click', function () {
      var b = realButton() || btn;
      var off = b.disabled || b.getAttribute('aria-disabled') === 'true';
      if (off) { b.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      b.click();
    });

    var box = document.querySelector('[id^="price-template"][id$="__main"]');
    var mo = new MutationObserver(function () { render(); update(); });
    if (box) mo.observe(box, { childList: true, subtree: true, characterData: true });
    mo.observe(btn, { attributes: true, childList: true, subtree: true, characterData: true });
    setInterval(update, 500);
    render();
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
